export default () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 2.5H3.33333C2.59695 2.5 2 3.09695 2 3.83333V13.1667C2 13.903 2.59695 14.5 3.33333 14.5H12.6667C13.403 14.5 14 13.903 14 13.1667V3.83333C14 3.09695 13.403 2.5 12.6667 2.5Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
    />
    <mask
      id="mask0_7009_21318"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="5"
      width="8"
      height="7"
    >
      <path
        d="M11.1467 5.6462C11.3421 5.45108 11.6587 5.45129 11.8538 5.64669C12.0489 5.84208 12.0487 6.15867 11.8533 6.3538L6.84646 11.3538C6.64893 11.5511 6.32814 11.5484 6.13395 11.3478L4.1408 9.28944C3.94871 9.09106 3.9538 8.77452 4.15218 8.58243C4.35056 8.39034 4.66711 8.39543 4.8592 8.59381L6.49913 10.2874L11.1467 5.6462Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_7009_21318)">
      <path
        d="M11.1467 5.6462C11.3421 5.45108 11.6587 5.45129 11.8538 5.64669C12.0489 5.84208 12.0487 6.15867 11.8533 6.3538L6.84646 11.3538C6.64893 11.5511 6.32814 11.5484 6.13395 11.3478L4.1408 9.28944C3.94871 9.09106 3.9538 8.77452 4.15218 8.58243C4.35056 8.39034 4.66711 8.39543 4.8592 8.59381L6.49913 10.2874L11.1467 5.6462Z"
        fill="white"
      />
    </g>
  </svg>
);
